import React from 'react';
import OrganisationsAdminLayout from '../components/administration/OrganisationsAdminLayout';

function OrganisationsPage() {
  return <OrganisationsAdminLayout />;
}

export default OrganisationsPage;
